<template>
  <section>
    <p class="text-muted-foreground py-8 text-center">No recent searches</p>
  </section>
</template>
